import React from 'react';
import useOptions from '../../hooks/useOptions';
import RadioGroupField from 'components/RadioGroupField';
import { Field, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import InputField from 'components/InputField';
import validations from 'validations';

import './ProfitMeasureField.styles.scss';
import './ProfitMeasureField.styles.responsive.scss';

const ProfitMeasureField: React.FC = () => {
  const { profitMeasureOptions } = useOptions();
  const { t } = useTranslation();
  const {
    values: { profitMeasure },
  } = useFormState();

  return (
    <div className="profit-measure-field">
      <RadioGroupField
        name="profitMeasure"
        options={profitMeasureOptions}
        styled
      />
      <p>{t('andTheNumbers')}</p>
      <div className="profit-measure-field__numbers">
        {profitMeasure === 'pebitda' && (
          <>
            <Field
              name="compensationPaidToOwner"
              label={t('totalCompensationPaidOwner')}
              numberStyle="dottedNumber"
              required
              component={InputField}
              placeholder={t('amountPlaceholder')}
              validate={validations.composeValidators(
                validations.required(),
                validations.positiveNumbersOnly(
                  t('onlyPositiveNumbersAreAllowed'),
                ),
              )}
            />
            <span />
          </>
        )}
        <Field
          name="profit"
          label={t('whatWasProfitAmount')}
          numberStyle="dottedNumber"
          required
          component={InputField}
          placeholder={t('amountPlaceholder')}
          validate={validations.composeValidators(
            validations.required(),
            validations.positiveNumbersOnly(t('onlyPositiveNumbersAreAllowed')),
          )}
        />
        <span />
      </div>
    </div>
  );
};

export default ProfitMeasureField;
